import { startQuestionsTour } from '@/utils/tour';

export default {
  methods: {
    checklistItemCompleted(item) {
      const checklistState = this.$store.getters['checklistStates/get'][this.checklist?.id];
      if (checklistState) {
        return checklistState.completedChecklistItemIds.includes(item.id);
      }
    },
    checklistItemRoute(item) {
      if (this.checklistItemCompleted(item) || !item.navigationItemId) {
        return {};
      } else {
        const navItem = this.$store.getters['navigationItems/navigationItems'][item.navigationItemId];
        if (item.action === 'Complete Tooltips Tour') {
          startQuestionsTour.apply(this, [navItem.resourceId]);
        }
        return navItem?.route || {};
      }
    },
  },
};